<template>
  <div class="flex flex-wrap gap-3">
    <span
      v-for="contact in contacts"
      :key="contact.id"
      :title="getContactTitle(contact)"
      class="inline-flex"
    >
      <contact-avatar
        :contact="(contact as Contact)"
        :contact-type="contact.type"
      />
    </span>
    <span
      v-for="number in externalContactsNumbers"
      :key="number"
      :title="number"
      class="inline-flex"
    >
      <contact-avatar
        :name="number"
        contact-type="pstnGuest"
      />
    </span>
  </div>
</template>

<script setup lang="ts">
import { ContactAvatar } from '@/entities/contact-avatar'

import { Contact, ExternalContact } from '@/shared/types/api'

defineProps<{
    contacts: (Contact | ExternalContact)[],
    externalContactsNumbers?: string[]
}>()

const getContactTitle = (contact: Contact | ExternalContact): string => {
  if (contact.name?.trim()) {
    return contact.name.trim()
  }

  if (contact.internalNumber?.trim()) {
    return contact.internalNumber.trim()
  }

  if ('mobilePhone' in contact && contact.mobilePhone?.trim()) {
    return contact.mobilePhone.trim()
  }

  return contact.id
}
</script>
